<div class="d-flex bd-highlight">
   <div class="p-2 w-100 bd-highlight">?</div>
   <div class="p-2 flex-shrink-1 bd-highlight">breadcrumb</div>
</div>
